export default __webpack_public_path__ + "static/weare-4-90d0ca17b56ef06a9b9337b48801a84f.png";